<article class="word-hanja-layout1"
         #popupContainer
         [style.top]="popupTop + 'px'"
         (click)="onVoid($event)">

  <div class="tooltip-wrap"
       *ngIf="hanja && errorTxt">
    <div class="tooltip-head-box hun">
      <div class="hanja">{{ hanja }}</div>
      <div class="hun-eum-box" *ngIf="firstHun || hangul">
        <span class="hun-txt">{{ firstHun }}</span>
        <span class="eum-txt">{{ hangul }}</span>
      </div>
      <a class="tooltip-close-btn"
         (click)="onClose($event)"></a>
    </div>
    <div class="tooltip-item">
      <div class="err">{{ errorTxt }}</div>
    </div>
  </div>

  <div class="tooltip-wrap"
       *ngIf="hanja && !errorTxt">
    <div class="tooltip-head-box hun">
      <ng-container *ngIf="hanjaWordInfo">
        <div class="hanja">{{ hanjaWordInfo.hanja }}</div>
        <div class="hun-eum-box" *ngIf="firstHun || hangul">
          <span class="hun-txt">{{ firstHun }}</span>
          <span class="eum-txt">{{ hangul }}</span>
        </div>
        <!-- TODO: HanjaService 제거 후 삭제 예정 - 획수/부수 정보 표시 영역
        <div class="hanja-box">
          <div class="hanja-stroke">
            <span class="label-txt">획수</span>
            <span class="hanja-info">{{ hanjaWordInfo.stroke }}</span>
          </div>
          <div class="hanja-stroke">
            <span class="label-txt">부수</span>
            <span class="hanja-info">{{ hanjaWordInfo.busu.busu }} : {{ hanjaWordInfo.busu.meaning }}</span>
            <span class="label-txt">부수 획수</span>
            <span class="hanja-info">{{ hanjaWordInfo.busu.stroke }}</span>
          </div>
        </div>
        -->
      </ng-container>
      <a class="tooltip-close-btn"
         (click)="onClose($event)"></a>
    </div>

    <ng-container *ngIf="hanjaWordInfo">

      <div *ngFor="let word of listWord"
           class="tooltip-item">
        <app-word-disp class="word"
                       [word]="word"
                       [style.min-width.px]="wordColumnMinWidth"></app-word-disp>
        <div class="meaning">{{ GetMeaning(word) }}</div>
      </div>

      <div class="tooltip-item"
           *ngIf="hanjaWordInfo?.word_total_count === 0">
        <div class="err">본 사전에서는 동자로 사용 되었습니다.</div>
      </div>

      <div class="tooltip-item"
           *ngIf="hanjaWordInfo?.word_total_count ?? 0 > 0">
        <div class="tooltip-link-box">
          <a class="tooltip-link-btn"
             (click)="onCloseMore($event)">
            <span class="txt more"
                  *ngIf="getMoreTxt()">{{ getMoreTxt() }}</span>
            <span class="txt">{{ getMoreTxt() ? "전체 보기" : "자세히 보기" }}</span>
            <i class="ic ic-link"></i>
          </a>
        </div>
      </div>
    </ng-container>

    <div *ngIf="IsLoading"
         class="reload-icon">
      <img src="assets/img/loading_icon.gif">
    </div>

  </div>

</article>
